module.exports = __webpack_public_path__ + "static/media/book_245.3972013f.jpg";